<div class="ds-grid ds-grid--3">
	<!-- Primary Radio -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Primary Radio</h3>
			<p class="ds-example__header-subtitle">Basic radio button</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Status'"
				name="status-group"
				[options]="statusOptions"
				(radioChange)="onRadioChange('Status', $event)"
				[(ngModel)]="selectedStatus">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedStatus || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Success Radio -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Success Radio</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Notification method'"
				name="notification-group"
				[options]="notificationOptions"
				color="success"
				(radioChange)="onRadioChange('Notification', $event)"
				[(ngModel)]="selectedNotification">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--success">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedNotification || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Info Radio with Icon -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Info Radio</h3>
			<p class="ds-example__header-subtitle">With icon and tooltip</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Priority level'"
				[icon]="'fa-solid fa-info-circle'"
				[tooltip]="'Choose the priority for this task'"
				name="priority-group"
				[options]="priorityOptions"
				color="info"
				(radioChange)="onRadioChange('Priority', $event)"
				[(ngModel)]="selectedPriority">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--info">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedPriority || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Warning Radio -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Warning Radio</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Action'"
				name="action-group"
				[options]="actionOptions"
				color="warning"
				(radioChange)="onRadioChange('Action', $event)"
				[(ngModel)]="selectedAction">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--warning">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedAction || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Danger Radio -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Danger Radio</h3>
			<p class="ds-example__header-subtitle">With icon support</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Delete option'"
				name="delete-group"
				[options]="deleteOptions"
				color="danger"
				(radioChange)="onRadioChange('Delete', $event)"
				[(ngModel)]="selectedDelete">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--danger">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedDelete || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Disabled Radio -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Disabled Radio</h3>
			<p class="ds-example__header-subtitle">Non-interactive state</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Disabled options'"
				name="disabled-group"
				[options]="disabledOptions"
				color="neutral"
				[disabled]="true"
				(radioChange)="onRadioChange('Disabled', $event)"
				[(ngModel)]="selectedDisabled">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value ds-value--disabled">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedDisabled || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Vertical Display Radio -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Vertical Display</h3>
			<p class="ds-example__header-subtitle">Options stacked vertically</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				[label]="'Preferred contact method'"
				name="vertical-group"
				[options]="statusOptions"
				[verticalDisplay]="true"
				(radioChange)="onRadioChange('Vertical', $event)"
				[(ngModel)]="selectedVertical">
			</eif-custom-radio>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedVertical || 'No value' }}</div>
			</div>
		</div>
	</div>

	<!-- Required Radio (validation on button) -->
	<div class="ds-example">
		<div class="ds-example__header">
			<h3 class="ds-example__header-title">Required Radio</h3>
			<p class="ds-example__header-subtitle">Must select an option, validate on button</p>
		</div>
		<div class="ds-example__content">
			<eif-custom-radio
				#validationRadio
				[label]="'Agreement'"
				name="required-group"
				[options]="requiredOptions"
				[validationRules]="requiredRadioRules"
				(radioChange)="onRadioChange('Required', $event)"
				(validationChange)="onValidationChange($event)"
				[(ngModel)]="selectedRequired">
			</eif-custom-radio>
			<eif-custom-button
				[text]="'Validate'"
				[type]="'button'"
				[size]="'small'"
				[preIcon]="'fa-solid fa-check'"
				(action)="validationRadio.validate()">
			</eif-custom-button>
		</div>
		<div class="ds-example__footer">
			<div class="ds-value">
				<div class="ds-value__label">Value:</div>
				<div class="ds-value__content">{{ selectedRequired || 'No value' }}</div>
			</div>
			<div class="ds-value ds-mt-1">
				<div class="ds-value__label">Valid:</div>
				<div class="ds-value__content">{{ validationValid ? 'Yes' : 'No' }}</div>
			</div>
		</div>
	</div>
</div>
